export const householdReviews = [
  {
    "moduleId": "taiwan-tax",
    "title": "台灣投資稅務｜114所得年度",
    "questions": [
      {
        "id": "taiwan-tax-review-1",
        "lessonId": "tw-tax-map",
        "question": "114所得年度整理投資對帳單，看到賣出總收款80,000元，最合理的第一步是？",
        "options": [
          "全部視為股利",
          "核對本金、成本、費用與所得分類後，再確認適用規定",
          "只看入帳幣別決定課稅"
        ],
        "answer": 1,
        "explanation": "總收款不等於所得，資料分類是計算與申報的起點。"
      },
      {
        "id": "taiwan-tax-review-2",
        "lessonId": "tw-dividend-tax",
        "question": "114所得年度境內居住者全戶適用股利300,000元，採合併計稅時股利可抵減稅額的中間數是多少？",
        "options": [
          "25,500元；完整全戶稅負仍須另算",
          "84,000元；這就是合併選項最終稅負",
          "80,000元；不論股利多少都固定抵滿"
        ],
        "answer": 0,
        "explanation": "300,000×8.5%＝25,500元，未達每戶80,000元上限；不是必定退稅金額。"
      },
      {
        "id": "taiwan-tax-review-3",
        "lessonId": "tw-overseas-income",
        "question": "114所得年度全戶海外所得150萬元、其他所有應計入項目合計100萬元，哪項解讀正確？",
        "options": [
          "只計入超過100萬元的50萬元",
          "因海外所得低於750萬元，完全不用整理",
          "海外所得全數計入，合計基本所得額250萬元，這一步尚未產生額外基本稅額"
        ],
        "answer": 2,
        "explanation": "已達計入門檻，海外所得須全數計入；本例合計低於114年度750萬元基本所得額免稅額，一般申報仍須正確處理。"
      },
      {
        "id": "taiwan-tax-review-4",
        "lessonId": "tw-tax-records",
        "question": "某跨境所得通知列總額12,000元、預扣1,200元、費用100元。哪個紀錄較完整？",
        "options": [
          "只留10,700元淨入帳就能判定全年稅負結清",
          "分別保留總所得、預扣、費用與淨入帳10,700元，再核對適用申報規則",
          "把1,200元預扣也當成費用重複扣除"
        ],
        "answer": 1,
        "explanation": "12,000−1,200−100＝10,700元。淨入帳只說明收付款，不能取代申報與扣抵證明。"
      }
    ]
  },
  {
    "moduleId": "insurance",
    "title": "用保障需求看保險｜綜合檢查",
    "questions": [
      {
        "id": "insurance-review-1",
        "lessonId": "insurance-gap",
        "question": "假設同一風險事件資金需求500萬元、可用資源100萬元、適用保障200萬元，且均不重複，簡化缺口多少？",
        "options": [
          "200萬元，但仍要核對條款與承受能力",
          "400萬元，保險給付不能列為資源",
          "500萬元，資源不影響缺口"
        ],
        "answer": 0,
        "explanation": "500−100−200＝200萬元；僅為題設盤點，不是指定投保額度。"
      },
      {
        "id": "insurance-review-2",
        "lessonId": "insurance-periods",
        "question": "主約宣稱終身保障，附約一年期。可以由主約名稱直接推定附約也保終身嗎？",
        "options": [
          "可以，同一張保單都一定同期間",
          "不行，要查附約保障期間、續保年齡與費率條件",
          "只要保費一次繳完，就全部保終身"
        ],
        "answer": 1,
        "explanation": "主約與附約可能不同期間，繳費年期也不能取代保障期間。"
      },
      {
        "id": "insurance-review-3",
        "lessonId": "insurance-terms",
        "question": "某假想條款明定先扣自負額2,000元再受上限12,000元限制，符合費用18,000元，給付多少？",
        "options": [
          "18,000元",
          "16,000元",
          "12,000元"
        ],
        "answer": 2,
        "explanation": "min(18,000−2,000,12,000)＝12,000元，只適用題設條款。"
      },
      {
        "id": "insurance-review-4",
        "lessonId": "insurance-surrender",
        "question": "某保單累積繳費200,000元、假設可領解約金140,000元且無其他扣款，哪個判斷完整？",
        "options": [
          "現金差60,000元，還要檢查停止保障及換約條件",
          "差額60,000元依法必定補發",
          "宣告利率為正，所以解約一定不會少拿"
        ],
        "answer": 0,
        "explanation": "200,000−140,000＝60,000元；不能只由現金差判定契約全部價值或是否應解約。"
      }
    ]
  },
  {
    "moduleId": "mortgage",
    "title": "房貸與買房現金流｜綜合檢查",
    "questions": [
      {
        "id": "mortgage-review-1",
        "lessonId": "mortgage-amortization",
        "question": "某期付款22,000元，其中利息6,000元，無其他費用，本金減少多少？",
        "options": [
          "22,000元",
          "16,000元",
          "6,000元"
        ],
        "answer": 1,
        "explanation": "22,000−6,000＝16,000元。家庭仍須備足完整22,000元付款。"
      },
      {
        "id": "mortgage-review-2",
        "lessonId": "mortgage-grace-rates",
        "question": "假設120萬元房貸前一年只按月付息，沒有還本金或其他變動，期末本金是多少？",
        "options": [
          "120萬元；寬限期不會自行降低本金",
          "等於120萬元減已繳全部利息",
          "零，因為每月有付款"
        ],
        "answer": 0,
        "explanation": "只付息沒有還本金；之後如何攤還還要看剩餘期數、利率與契約。"
      },
      {
        "id": "mortgage-review-3",
        "lessonId": "mortgage-total-cost",
        "question": "兩方案利率接近，但金額、費用、優惠期和提前清償條件不同，怎麼比較？",
        "options": [
          "只看最低廣告利率",
          "把一次費用率直接加利率就是完整APR",
          "固定比較條件，核對總費用年百分率與清償條款，再看實際期間現金流"
        ],
        "answer": 2,
        "explanation": "總費用年百分率有計算假設，不能直接比較不同條件或漏掉限制清償成本。"
      },
      {
        "id": "mortgage-review-4",
        "lessonId": "mortgage-cash-buffer",
        "question": "自備價款180萬元、其他購屋支出20萬元、保留預備金40萬元，可用存款210萬元，現金缺口多少？",
        "options": [
          "0元",
          "30萬元",
          "60萬元"
        ],
        "answer": 1,
        "explanation": "180＋20＋40−210＝30萬元，預備金不能與自備款重複使用。"
      }
    ]
  },
  {
    "moduleId": "household",
    "title": "一起整理家庭財務｜綜合檢查",
    "questions": [
      {
        "id": "household-review-1",
        "lessonId": "household-shared-cash",
        "question": "夫妻在同一家庭合併範圍內，把20,000元轉到共同帳戶，再支付20,000元房租，家庭對外支出多少？",
        "options": [
          "40,000元",
          "20,000元",
          "0元"
        ],
        "answer": 1,
        "explanation": "轉入共同帳戶為內部移動；只有房租20,000元離開合併範圍。"
      },
      {
        "id": "household-review-2",
        "lessonId": "household-sinking-funds",
        "question": "八個月後要付72,000元，已有24,000元，不計利息，每月需準備多少？",
        "options": [
          "3,000元",
          "9,000元",
          "6,000元"
        ],
        "answer": 2,
        "explanation": "(72,000−24,000)÷8＝6,000元；不能一律把年費除12。"
      },
      {
        "id": "household-review-3",
        "lessonId": "household-debt-cost",
        "question": "同樣額外還本金12,000元，無其他差異時，年利率15%與3%的兩筆債，下個月各少多少利息？",
        "options": [
          "150元與30元",
          "1,800元與360元",
          "兩筆都少12,000元"
        ],
        "answer": 0,
        "explanation": "12,000×15%÷12＝150元；12,000×3%÷12＝30元。實際仍要看契約費用與現金需求。"
      },
      {
        "id": "household-review-4",
        "lessonId": "household-resilience",
        "question": "必要現金支出50,000元、事件後收入35,000元，可動用預備金60,000元，假設不變可補幾個月缺口？",
        "options": [
          "約1.2個月",
          "4個月",
          "約1.7個月"
        ],
        "answer": 1,
        "explanation": "每月缺口15,000元，60,000÷15,000＝4個月；除以全部支出回答的是另一個問題。"
      }
    ]
  }
];
